import React, { useEffect, useState } from "react";
import styles from "./Filtering.module.sass";
import cn from "classnames";
import Filters from "components/Filters";
import { adminUsersRoles, adminUsersStatuses } from "data/dataArrays";
import Dropdown from "components/Dropdown";
import { useHistory, useLocation } from "react-router";

const Filtering = ({ currentPage, search }) => {
  const [role, setRole] = useState("Wybierz rolę");
  const [status, setStatus] = useState("Wybierz status");

  const searchUrl = useLocation().search;
  const history = useHistory();

  const handleFiltersClear = () => {
    history.push({
      search: `page=${currentPage}`,
    });
    setRole("Wybierz rolę");
    setStatus("Wybierz status");
  };

  const getUrlParams = () => {
    let index;

    let role = new URLSearchParams(searchUrl).get("role");
    adminUsersRoles.forEach((item, i) => {
      if (item.value === role) {
        index = i;
        return;
      }
    });

    if (role !== null && index !== undefined)
      setRole(adminUsersRoles[index].name);
    console.log(role);

    let status = new URLSearchParams(searchUrl).get("is_banned");
    adminUsersStatuses.forEach((item, i) => {
      if (item.value === status) {
        index = i;
        return;
      }
    });

    if (status !== null && index !== undefined)
      setStatus(adminUsersStatuses[index].name);
    console.log(status);
  };

  useEffect(() => {
    getUrlParams();
  }, []);

  const pushUrlParams = () => {
    let params = `page=${currentPage}`;

    let index = -1;
    adminUsersRoles.forEach((item, i) => {
      if (item.name === role) {
        index = i;
        return;
      }
    });
    if (index !== -1) {
      params = params + `&role=${adminUsersRoles[index].value}`;
    }

    index = -1;
    adminUsersStatuses.forEach((item, i) => {
      if (item.name === status) {
        index = i;
        return;
      }
    });
    if (index !== -1) {
      params = params + `&is_banned=${adminUsersStatuses[index].value}`;
    }

    history.push({
      search: params,
    });
  };

  useEffect(() => {
    pushUrlParams();
  }, [searchUrl, currentPage, role, status]);

  return (
    <Filters className={styles.filter} title="Filtrowanie">
      <div className={styles.filter_body}>
        <Dropdown
          label="Rola"
          options={adminUsersRoles.map((item) => item.name)}
          value={role}
          setValue={setRole}
        />
        <Dropdown
          label="Status"
          options={adminUsersStatuses.map((item) => item.name)}
          value={status}
          setValue={setStatus}
        />

        <button
          className={cn("button", styles.button)}
          onClick={handleFiltersClear}
        >
          Resetuj filtry
        </button>
      </div>
    </Filters>
  );
};

export default Filtering;
